import { MainAIMaskResolver } from "@/io/assets/ai-mask/main-ai-mask-resolver"
import { getEditor } from "@/utils/useEditor"
import { MaskOverlayController } from "./mask-overlay-controller"

export const MainMaskOverlayController = new MaskOverlayController(getEditor, MainAIMaskResolver)
